import { React, PT } from '@gasbuddy/react';
import moment from 'moment';
import JSONTree from 'react-json-tree';
import { Table, Popup } from 'semantic-ui-react';

export const ActionTable = ({ actions }) => (
  <Table basic="very" selectable style={{ tableLayout: 'fixed', fontSize: '0.9em' }}>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell width={3} textAlign="center">Date</Table.HeaderCell>
        <Table.HeaderCell textAlign="center">Action</Table.HeaderCell>
        <Table.HeaderCell>By</Table.HeaderCell>
      </Table.Row>
    </Table.Header>
    {actions
      && (
      <Table.Body>
        {actions.map(a => (
          <Popup
            key={a.id}
            wide="very"
            on="click"
            trigger={(
              <Table.Row>
                <Table.Cell>{moment(a.created_at).format('M/DD/YY HH:mm')}</Table.Cell>
                <Table.Cell textAlign="center">{(a.value && a.value.action) || a.action_type}</Table.Cell>
                <Table.Cell>{a.actor.description}</Table.Cell>
              </Table.Row>
)}
            content={<JSONTree data={a.value || {}} />}
          />
        ))}
      </Table.Body>
      )
    }
  </Table>
);

ActionTable.propTypes = {
  actions: PT.arrayOf(PT.shape({
    created_at: PT.string,
    action_type: PT.string,
    actor: PT.shape({
      description: PT.string,
    }),
  })),
};

ActionTable.defaultProps = {
  actions: [],
};
